import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=adf9aea6&scoped=true&"
import script from "./FooterPage.vue?vue&type=script&lang=js&"
export * from "./FooterPage.vue?vue&type=script&lang=js&"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=adf9aea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf9aea6",
  null
  
)

export default component.exports